<template>
  <div class="bg-white border-b border-gray-200">
    <nav class="px-3 md:px-6 max-w-7xl mx-auto">
      <!-- 桌面端：平均分布 -->
      <div class="hidden md:flex">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          @click="$emit('tab-change', tab.id)"
          :class="[
            'flex-1 whitespace-nowrap py-4 px-1 border-b-2 transition-colors text-center',
            activeTab === tab.id
              ? 'border-blue-600 text-blue-600'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
          ]"
        >
          {{ tab.label }}
        </button>
      </div>
      
      <!-- 移动端：水平滚动 -->
      <div class="md:hidden overflow-x-auto">
        <div class="flex min-w-max">
          <button
            v-for="tab in tabs"
            :key="tab.id"
            @click="$emit('tab-change', tab.id)"
            :class="[
              'whitespace-nowrap py-4 px-4 border-b-2 transition-colors',
              activeTab === tab.id
                ? 'border-blue-600 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            ]"
          >
            {{ tab.label }}
          </button>
        </div>
      </div>
    </nav>
  </div>
</template>

<script setup>
defineProps({
  activeTab: {
    type: String,
    required: true
  }
})

defineEmits(['tab-change'])

const tabs = [
  { id: "teaching-project", label: "教研项目" },
  { id: "research-project", label: "科研项目" },
  { id: "conference", label: "学术会议" },
  { id: "paper", label: "论文" },
  { id: "patent", label: "专利" },
  { id: "software", label: "软著" },
  { id: "monograph", label: "专著" },
  { id: "award", label: "荣誉获奖" },
  { id: "other", label: "其他" },
]
</script>